import React from "react";
import { useSelector } from "react-redux";

const currentYear = new Date().getFullYear();
export default function Footer() {
  const { sidebarOpen } = useSelector((state) => state.users);
  return (
      <div className={!sidebarOpen ? "content-wrapper pt-md-3" : null} style={{paddingTop: "5px !important"}}>
        <footer
          style={{ backgroundColor:"white", padding:"10px", width: "100%", position: "fixed", bottom: "0"}}
        >
          <div className="float-right d-none d-sm-block" style={{position: "fixed", left: "86%"}}>
            <b>Version</b> 1.0.1329
          </div>
          <strong>Copyright &copy; {currentYear}</strong> All rights reserved.
        </footer>
      </div>
  );
}

